// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { ProvidersService } from "../../services/ProvidersService";
import LoadingSpinner from "../../components/LoadingSpinner";
import {Box} from "@mui/material";
import { UserService } from '../../services/UserService';
import { CalendarService } from '../../services/CalendarService';

const PrivateRoute = ({ children }) => {
   const { keycloak, initialized } = useKeycloak();

   if (!initialized) {
      return <Box style={{height: "calc(100vh - 220px)", width: "100vw", alignContent: "center"}}>
         <LoadingSpinner statusMessage={"Validating your identity"} />
      </Box>;
   }

   if (!keycloak.authenticated) {
      // Pass the current location in state so the login page knows where to return.
      return <Navigate to="/login" state={{ from: window.location.href }} replace={true} />;
   }
   ProvidersService.keycloak = keycloak;
   UserService.keycloak = keycloak;
   CalendarService.keycloak = keycloak;
   return children;
};

export default PrivateRoute;
